import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: () => ({
    id: null,
    name: null,
    slug: null,
    description: null,
    store_payment_methods: []
  }),
  mutations: {
    MY_STORE_ID(context, payload) {
      if (!payload) {
        context.id = null
        context.name = null
        context.slug = null
        context.description = null
      } else {
        context.id = payload.id
        context.name = payload.name
        context.slug = payload.slug
        context.description = payload.description
        context.store_payment_methods = payload.store_payment_methods
      }
    }
  },
  actions: {
    async MY_STORES({ commit, rootState, rootCommit }) {
      const data = {
        headers: {
          Authorization: 'Bearer ' + rootState.access_token
        }
      }
      const store = await axios.get('module/stores', data)
      commit('MY_STORE_ID', store.data.data)
      return store.data
    },
    async DELETE_STORE({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .delete(`module/stores/${payload}`, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response.data)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async CREATE_STORE({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .post('module/stores', payload, data)
          .then(response => {
            commit('MY_STORE_ID', response.data.data)
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async PUT_UPDATE_STORE({ state, commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .put(`module/stores/${state.id}`, payload, data)
          .then(response => {
            commit('MY_STORE_ID', response.data.data)
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async UPDATE_STORE({ state, commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + rootState.access_token
          },
          params: { _method: 'put' }
        }
        commit('loading', null, { root: true })
        axios
          .post(`module/stores/${state.id}`, payload, data)
          .then(response => {
            commit('MY_STORE_ID', response.data.data)
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async CREATE_PRODUCT_STORE({ commit, rootState, state }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }

        commit('loading', null, { root: true })
        axios
          .post(`module/stores/${state.id}/products`, payload, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response.data)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async UPDATE_PRODUCT_STORE({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        const product = payload.product_id
        delete payload.product_id
        commit('loading', null, { root: true })
        axios
          .put(`module/stores/${state.id}/products/${product}`, payload, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async UPLOAD_PRODUCT_IMAGE({ commit, rootState }, payload) {
      const data = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + rootState.access_token
        }
      }
      const product = payload.product_id
      delete payload.product_id
      const image = await axios.post(
        `/module/products/${product}/image`,
        payload.form,
        data
      )
      return image.data
    },
    async DELETE_PRODUCT_IMAGE({ commit, rootState }, payload) {
      const data = {
        headers: {
          Authorization: 'Bearer ' + rootState.access_token
        }
      }
      return await axios.delete(
        `/module/products/${payload.product_id}/image/${payload.image_id}`,
        data
      )
    },
    async MY_PRODUCT_BY_STORE({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          params: { page: payload.page, search: payload.search },
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .get(`module/stores/${state.id}/products`, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async LOAD_PRODUCT_BY_STORE({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .get(
            `module/stores/${payload.store_id}/products/${payload.product_id}`,
            data
          )
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response.data)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async DELETE_PRODUCT_BY_STORE({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .delete(
            `module/stores/${payload.store_id}/products/${payload.product_id}`,
            data
          )
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async LOAD_CATEGORIES_BY_STORE({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .get(`module/stores/${payload}/categories`, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response.data)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async LOAD_CATEGORY_BY_ID({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .get(`module/stores/${state.id}/categories/${payload}`, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response.data)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async DELETE_CATEGORY_BY_ID({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .delete(`module/stores/${state.id}/categories/${payload}`, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response.data)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async CREATE_CATEGORIES_BY_STORE({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .post(`module/stores/${payload.store_id}/categories`, payload, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async UPDATE_CATEGORIES_BY_STORE({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .put(
            `module/stores/${state.id}/categories/${payload.id}`,
            payload,
            data
          )
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async LOAD_CUSTOMERS({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .get(`module/stores/${state.id}/customers`, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response.data)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async STORE_CUSTOMER({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .post(`module/stores/${state.id}/customers`, payload, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async UPDATE_CUSTOMER({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .put(
            `module/stores/${state.id}/customers/${payload.id}`,
            payload,
            data
          )
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    },
    async GET_CUSTOMER_BY_ID({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          headers: {
            Authorization: 'Bearer ' + rootState.access_token
          }
        }
        commit('loading', null, { root: true })
        axios
          .get(`module/stores/${state.id}/customers/${payload}`, data)
          .then(response => {
            commit('loadingFail', null, { root: true })
            resolve(response.data)
          })
          .catch(error => {
            commit('loadingFail', null, { root: true })
            reject(error)
          })
      })
    }
  },
  getters: {}
}
